import { component_tool, framework_tool, utils_tool } from '@/tool';
let { Storage } = utils_tool;
import React from 'react';
import * as local_urls from '../../../constants/constants_url';
import { actionUtils } from '@/utils'

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;

let { WizModal } = component_tool;
//配置项
let componentName = 'model';

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "标识Key",
    name: "key",
    dataIndex: "key",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "版本",
    name: "version",
    dataIndex: "version",
    tableItem: {}
  },
  {
    title: "部署ID",
    name: "deploymentId",
    dataIndex: "deploymentId",
    tableItem: {}
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  },
  {
    title: "最后修改时间",
    name: "lastUpdateTime",
    dataIndex: "lastUpdateTime",
    tableItem: {}
  }
];

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:['add','delete'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "工作流在线流程设计编辑",
                    diy: (e) => {
                      const addModelUrl = `${urls.kUrlAddModel}?access-token=${Storage.getStorage("token")}`;
                      return (
                        <iframe src={addModelUrl} width="100%" height="900" frameBorder="no"/>
                      )
                    },
                    onCancel: () => {
                      e.doAction(apis.list)
                    },
                    footer:null,
                    width: 1500,
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort:['update','release'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "工作流在线流程设计编辑",
                  diy: (e) => {
                    const updateModelUrl = `${urls.kUrlUpdateModel}?id=${e.record.id}&access-token=${Storage.getStorage("token")}`;
                    return (
                      <iframe src={updateModelUrl} width="100%" height="900" frameBorder="no"/>
                    )
                  },
                  onCancel: () => {
                    e.doAction(apis.list)
                  },
                  footer:null,
                  width: 1500,
                }
              }
            }
          },
          {
            key: "release",
            custom: true,
            params: { children: "发布"},
            //需要根据接口数据变换按钮文字内容的传入方式
            textFormat: {},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "deploy",
                apiParams: {}
              },
              formatParams: (rows, record, filters,callback) => {
                const content = `您确定要发布流程模型为流程定义吗?`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                    })
                  },
                  onCancel() {}
                });
                return null
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete:true,
          update:true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  add:{
    path: `${componentName}/addModel`,
    payload: {
      key: `${componentName}@addModel`,
    }
  },
  delete:{
    path: `${componentName}/deleteModel`,
    payload: {
      key: `${componentName}@deleteModel`,
    }
  },
  update:{
    path: `${componentName}/updateModel`,
    payload: {
      key: `${componentName}@updateModel`,
    }
  },
  deploy:{
    path: `${componentName}/deployModel`,
    payload: {
      key: `${componentName}@deployModel`,
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
